// extracted by mini-css-extract-plugin
export default {"mainMenuButton":"MobileMenuButton_mainMenuButton__nShG5"};